import { render } from "./create_new_orgainsation.vue?vue&type=template&id=0b97087a&scoped=true"
import script from "./create_new_orgainsation.vue?vue&type=script&lang=js"
export * from "./create_new_orgainsation.vue?vue&type=script&lang=js"

import "./create_new_orgainsation.vue?vue&type=style&index=0&id=0b97087a&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b97087a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QInput,QBtn,QToggle});
